<template>
  <div class="home">
    <h2 class="title">济宁市劳动纠纷问题反映</h2>
    <van-form
      label-width="4rem"
      error-message-align="right"
      input-align="right"
      @submit="onSubmit"
      ref="forms"
    >
      <van-field
        v-model="form.projectName"
        name="涉事单位（项目）名称"
        placeholder="请输入项目名称"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          涉事单位（项目）名称
        </template>
      </van-field>
      <van-field
        label-width="5.5rem"
        readonly
        clickable
        :value="form.projectAreaName"
        name="所在县（市、区）"
        right-icon="arrow"
        placeholder="请选择"
        :rules="[{ required: true, message: '' }]"
        @click="areaShow = true"
      >
        <template #label>
          <span class="ts">*</span>
          所在县（市、区）
        </template>
      </van-field>
      <van-field
        label-width="5.5rem"
        v-model="form.street"
        name="所在乡镇（街道）"
        placeholder="请输入"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          所在乡镇（街道）
        </template>
      </van-field>
      <van-field
        v-model="form.reflectName"
        name="反映人姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          反映人姓名
        </template>
      </van-field>
      <van-field
        v-model="form.reflectTel"
        name="反映人电话"
        placeholder="请输入电话"
        :rules="[
          { required: true, message: '' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }
        ]"
      >
        <template #label>
          <span class="ts">*</span>
          反映人电话
        </template>
      </van-field>
      <!-- 验证码 -->
      <tel-code ref="telCode"></tel-code>
      <van-field
        v-model="form.reflectIdcard"
        name="反映人身份证号"
        placeholder="请输入身份证号"
        :rules="[{ validator: sfzVal, message: '身份证号格式错误！' }]"
      >
        <template #label>
          <span class="ts">&nbsp;</span>
          反映人身份证号
        </template>
      </van-field>

      <van-field
        v-model="form.backPayPerson"
        name="人数(单位:人)"
        placeholder="请输入人数"
        :rules="[{ validator: rsVal, message: `格式错误,请输入正整数！` }, 1]"
      >
        <template #label>
          <span class="ts">&nbsp;</span>
          人数(单位:人)
        </template>
      </van-field>
      <van-field
        v-model="form.backPayMoney"
        name="金额(单位:元)"
        placeholder="请输入金额"
        :rules="[
          {
            validator: jeVal,
            message: `格式错误,例如'100'！`
          }
        ]"
      >
        <template #label>
          <span class="ts">&nbsp;</span>
          金额(单位:元)
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        v-model="backPayDate"
        name="发生时间"
        placeholder="请选择日期"
        right-icon="arrow"
        @click="calenderShow = true"
      >
        <template #label>
          <span class="ts">&nbsp;</span>
          发生时间
        </template>
      </van-field>
      <van-field
        class="texts"
        v-model="form.backPaySummary"
        rows="3"
        type="textarea"
        autosize
        name="backPaySummary"
        placeholder="(请将欠薪过程描述清楚，并控制在500字以内)"
        maxlength="500"
        show-word-limit
        :rules="[{ required: true, message: '' }]"
        input-align="left"
      >
        <template #label>
          <span class="ts">*</span>
          基本情况摘要
        </template>
      </van-field>

      <van-field
        label-width="8rem"
        class="radios"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          是否曾经通过以下途径反应过上述欠薪问题
        </template>
        <template #input>
          <van-radio-group
            class="radioAll"
            v-model="form.reflectChannel"
            @change="radioFn()"
          >
            <van-radio
              name="向劳动保障监察机构举报，投诉"
              checked-color="#4967B7"
              >向劳动保障监察机构举报，投诉</van-radio
            >
            <van-radio
              name="向劳动人事争议仲裁部门申请仲裁"
              checked-color="#4967B7"
              >向劳动人事争议仲裁部门申请仲裁</van-radio
            >
            <van-radio name="向人民法院提起诉讼" checked-color="#4967B7"
              >向人民法院提起诉讼</van-radio
            >
            <van-radio name="其他途径" checked-color="#4967B7"
              >其他途径</van-radio
            >
            <van-radio
              name="未曾经通过以上反映过欠薪问题"
              checked-color="#4967B7"
              >未曾经通过以上反映过欠薪问题</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        v-if="form.reflectChannel != '未曾经通过以上反映过欠薪问题'"
        class="texts"
        v-model="form.reflectDetail"
        rows="3"
        type="textarea"
        autosize
        name=""
        placeholder="(请将情况描述清楚，并控制在200字以内)"
        maxlength="200"
        show-word-limit
        :rules="[{ required: true, message: '' }]"
        input-align="left"
      >
        <template #label>
          <span class="ts">*</span>
          详细说明情况
        </template>
      </van-field>
      <div class="info">
        （如向劳动保障监察机构举报，投诉；向劳动人事争议仲裁部门申请仲裁；向人民法院提起诉讼；其他途径）
        <br />
        （注：带“*”为必填项）
      </div>
      <div class="btns">
        <van-button
          color="#4967B7"
          class="submitBtn"
          type="info"
          native-type="submit"
          >提交</van-button
        >
        <van-button
          color="#4967B7"
          plain
          class="resetBtn"
          @click="resetFn()"
          native-type="button"
          >重置</van-button
        >
      </div>
    </van-form>
    <!-- //区市 -->
    <van-popup v-model="areaShow" round position="bottom">
      <van-picker
        show-toolbar
        :columns="areaList"
        value-key="bladeRegionName"
        :default-index="areaSelectIndex"
        @cancel="areaShow = false"
        @confirm="onAreaConfirm"
      />
    </van-popup>
    <!-- 主管部门 -->
    <!-- <van-popup v-model="industryShow" round position="bottom">
      <van-picker
        show-toolbar
        :columns="industryList"
        :default-index="industrySelectIndex"
        value-key="name"
        @cancel="industryShow = false"
        @confirm="onIndustryConfirm"
      />
    </van-popup> -->

    <van-calendar
      color="#4967B7"
      v-model="calenderShow"
      :min-date="new Date(2017, 1, 1)"
      @confirm="onDateConfirm"
    />
  </div>
</template>

<script>
let form = {
  projectId: "", //选填 项目id
  projectName: "", //必填	项目名称
  projectAreaCode: "", //必填	项目所在区域： 历下区， 高新区 地域编码
  projectAreaName: "", //必填	项目所在区域： 历下区， 高新区 地域名称
  projectTypeCode: "", //必填	项目类型 ： 住建，交通 传编码
  projectOwerId: "", //选填	项目建设方编号
  projectCompanyId: "", //选填	项目施工方编号
  street: "", //必填	所在乡镇（街道）
  reflectName: "", //必填	反馈人名称
  reflectTel: "", //必填	反馈人电话
  reflectIdcard: "", //必填	反馈人身份证号码
  reflectChannel: "未曾经通过以上反映过欠薪问题", //必填	反馈途径，传文字
  reflectDetail: "", //必填	反馈详情
  backPayPerson: "", //必填	欠薪人数
  backPayMoney: "", //必填	欠薪金额
  backPayDate: "", //必填	反映日期
  backPaySummary: "", //必填	欠薪情况摘要
};
import TelCode from "@/components/TelCode.vue";
export default {
  name: "Home",
  components: {
    TelCode
  },
  data() {
    return {
      areaShow: false, //区市
      areaList: [], //区市列表
      areaSelectIndex: 0,
      calenderShow: false, //日期模态框
      //主管部门
      industryList: [], //区市列表
      industrySelectIndex: 0,

      //验证码end
      industryShow: false, //起始日期模态框

      backPayDate: "", //
      form: JSON.parse(JSON.stringify(form))
    };
  },
  methods: {
    // 校验函数返回 true 表示校验通过，false 表示不通过
    //身份证号验证
    sfzVal(val) {
      if (!val) {
        return true;
      } else
        return /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          val
        );
    },
    //欠薪人数验证
    rsVal(val) {
      if (!val) {
        return true;
      } else return /^[1-9]\d*$/.test(val);
    },
    //欠薪金额
    jeVal(val) {
      if (!val) {
        return true;
      } else
        return /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          val
        );
    },
    //区市
    onAreaConfirm(value) {
      this.form.projectAreaCode = value.bladeRegionCode;
      this.form.projectAreaName = value.bladeRegionName;
      this.areaShow = false;
    },
    //主管部门
    // onIndustryConfirm(value) {
    //   this.form.projectTypeCode = value.id;
    //   this.industryShow = false;
    // },
    //日期
    formatDate(date, d1) {
      let s = `${date.getFullYear()}年${date.getMonth() +
        1}月${date.getDate()}日`;
      if (d1 == "-") {
        s = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      }
      return s;
    },
    //
    radioFn() {},
    onDateConfirm(date) {
      this.calenderShow = false;
      this.backPayDate = this.formatDate(date, "");
      this.form.backPayDate = this.formatDate(date, "-");
    },
    //验证途径选项，提交前调用
    isRefiect() {
      if (this.form.reflectChannel == "未曾经通过以上反映过欠薪问题") {
        this.form.reflectDetail = "";
      }
    },
    reset4() {
      //2021年12月30日13:38:09 删除字段
    },
    onSubmit(values) {
      this.isRefiect();
      this.reset4();
      this.$http
        .submit({
          ...this.form,
          phone: this.form.reflectTel,
          smsCode: this.$refs.telCode.telCode
        })
        .then(res => {
          if (res.result) {
            // this.$toast.success(res.msg);
            this.resetFn();
            this.$router.push("/submitSuccess");
          } else {
            this.$toast.fail("提交失败");
          }
        });
    },
    resetFn() {
      this.form = JSON.parse(JSON.stringify(form));
      this.backPayDate = "";
      this.$refs.telCode.telCode = "";
      // this.$refs.telCode.count = 2
      // this.form.backPaySummary = ""
      this.$refs.forms.resetValidation();
      // location.reload();
    },
    getAreaList() {
      return new Promise((resolve, reject) => {
        let data = { areaId: "3708" };
        this.$http.getArea(data).then(res => {
          this.areaList = res.filter(item => item.bladeRegionName !== "济宁市");
          resolve();
        });
        //reject();
      });
    },
    getIndustryList() {
      this.industryList = [];
      return new Promise((resolve, reject) => {
        this.$http.getIndustry({ areaId: "3708" }).then(res => {
          this.industryList = res;
          resolve();
        });

        //reject();
      });
    },
    //初始化区市、行业主管部门
    getDataInit() {
      Promise.all([this.getAreaList()])
        .then(res => {
          //成功
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    //获取区市和行业主管部门list
    this.getDataInit();
  },
  mounted() {
    // let demoform = {
    //   backPayDate: "2021-1-17",
    //   backPayMoney: "1212",
    //   backPayPerson: "121212",
    //   backPaySummary: "sjlfa",
    //   projectAreaCode: "3706",
    //   projectAreaName: "烟台市",
    //   projectCompanyId: "",
    //   street: "121212",
    //   projectId: "",
    //   projectName: "12121212",
    //   projectOwerId: "",
    //   projectTypeCode: "1",
    //   reflectChannel: "未曾经通过以上反映过欠薪问题",
    //   reflectDetail: "说明情况",
    //   reflectIdcard: "372330199302132457",
    //   reflectName: "基本情况摘要",
    //   reflectTel: "15168855914",
    // };
    // this.backPayDate = "2021年1月17日";
    // this.form = demoform;
  }
};
</script>

<style lang="less" scoped>
.home {
  padding: 10px;
  * {
    // border: 1px solid #ccc;
  }
  .title {
    font-size: 20px;
    text-align: center;
    color: #4967b7;
    font-weight: 400;
    line-height: 50px;
  }
  .van-cell {
    background-color: #f1f1f1;
    // padding: 10px;
    margin: 10px 0;
    // width: auto;
    border-radius: 5px;
  }

  .radioAll {
    .van-radio {
      line-height: 25px;
      height: 25px;
      font-size: 14px;
    }
  }
  .info {
    color: #4967b7;
    margin: 10px 0;
  }
  .btns {
    overflow: hidden;
    .van-button {
      width: 48%;
      border-radius: 7px;
    }
    .submitBtn {
      float: left;
    }
    .resetBtn {
      float: right;
    }
  }
  .radios {
    display: block;
    /deep/.van-field__control--custom {
      display: block;
    }
  }
  .texts {
    display: block;
    /deep/.van-field__control--custom {
      display: block;
    }
  }
  .validateBox{
    padding: 20px 20px;
    display: flex;
    align-items: center;
    img{
      width: 100px;
    }
  }

}
@media screen and (min-width: 1000px) {
  .home {
    width: 600px;
    margin: 0 auto;
  }
}
</style>
